import { log as pilog } from "../../common/utils/Logging";
export var shouldBlockAppEntry = function shouldBlockAppEntry(platform, upgradeResource) {
  var log = pilog.getLogger("UpgradeUtil shouldBlockAppEntry");
  log.debug("Calculating app entry for ".concat(platform, " ").concat(process.env.REACT_APP_VERSION, " "), upgradeResource);
  var blockAppEntry = false;
  var osContent = undefined; //if we don't know the platform or we don't have any platform resource, don't do anything

  if (!platform || !upgradeResource) {
    return {
      blockAppEntry: blockAppEntry,
      osContent: osContent
    };
  }

  try {
    if (upgradeResource[process.env.REACT_APP_VERSION]) {
      if (upgradeResource[process.env.REACT_APP_VERSION][platform]) {
        osContent = upgradeResource[process.env.REACT_APP_VERSION][platform].content;
        blockAppEntry = true;
      }
    }
  } catch (error) {
    log.error("Unable to parse content for ".concat(platform));
  }

  return {
    blockAppEntry: blockAppEntry,
    osContent: osContent
  };
};